module.exports = __webpack_public_path__ + "static/images/intro5_dabed86e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/intro5.png
// module id = 233
// module chunks = 1